<h2 mat-dialog-title>Stato richiesta valutazione (FHIR)</h2>
<mat-dialog-content>
  <p class="mb-2"><strong>ID operazione:</strong> <code>{{ operationId }}</code></p>
  @if (loading) {
    <div class="d-flex align-items-center gap-2 py-3">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Caricamento stato...</span>
    </div>
  } @else if (error) {
    <p class="text-danger mb-0">{{ error }}</p>
  } @else if (task) {
    <dl class="mb-0">
      <dt class="text-muted small">Stato</dt>
      <dd class="mb-2">{{ statusLabel }}</dd>
      @if (task.description) {
        <dt class="text-muted small">Descrizione</dt>
        <dd class="mb-2">{{ task.description }}</dd>
      }
      @if (errorMessage) {
        <dt class="text-muted small">Motivo fallimento</dt>
        <dd class="mb-2 text-danger">{{ errorMessage }}</dd>
      }
    </dl>
    <div class="mt-3">
      <button mat-button (click)="showRawJson = !showRawJson">
        {{ showRawJson ? 'Nascondi' : 'Mostra' }} risposta FHIR (JSON)
      </button>
      @if (showRawJson) {
        <pre class="bg-light p-2 small mt-2 mb-0 overflow-auto" style="max-height: 280px;"><code>{{ rawJson }}</code></pre>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>
